import { render, staticRenderFns } from "./NoteDetail.vue?vue&type=template&id=e08529b8&scoped=true&"
import script from "./NoteDetail.vue?vue&type=script&lang=js&"
export * from "./NoteDetail.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetail.vue?vue&type=style&index=0&id=e08529b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08529b8",
  null
  
)

export default component.exports